import { render } from "./Dot.vue?vue&type=template&id=a93bf248&scoped=true"
import script from "./Dot.vue?vue&type=script&lang=js"
export * from "./Dot.vue?vue&type=script&lang=js"

import "./Dot.vue?vue&type=style&index=0&id=a93bf248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93bf248"]])

export default __exports__